import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class BanksService {
  bankCount = new BehaviorSubject('');

  constructor(private http: HttpClient) { }
  userData = (JSON.parse(localStorage.getItem('currentUser')));
  
  userbanks(){
    let uacId = this.userData.data['uacid']
    
    let headers = new HttpHeaders();
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.token;
    var token = localStorage.getItem('wallet-token');
    headers = headers.append('access-token', token);
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    return this.http.get(`${environment.youmudraUrl}/v1/retailer/fetchbanks?uacid=${uacId}`,{headers:headers});
  }
  userbanks2(){
    
    let headers = new HttpHeaders();
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.token;
    var token = localStorage.getItem('wallet-token');
    headers = headers.append('authToken', token);

    return this.http.get(`${environment.validate_url}/ym/retailor/bank/getallbank`,{headers:headers});
  }
  userDistributorTree(){
    let headers = new HttpHeaders();
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
    var token = localStorage.getItem('wallet-token');

    headers = headers.append('authToken', token);
    headers = headers.append('apikey', environment.api_key);
   
    return this.http.get(`${environment.baseUrl}/v1/ym/retailor/getdistributor/tree`,{headers:headers});
  }
  deleteBank(accountDetails){
    console.log(accountDetails)
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data['walletToken'];
    var token = localStorage.getItem('wallet-token');
     var data={
      benificiaryid:accountDetails.beneficiary_id,
      wallet_token:token,
      id:accountDetails._id

      
     }
     let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    return this.http.post(`${environment.youmudraUrl}/v1/retailer/deletebank`,data,{headers:headers});
  }
  deleteBank2(bankAccount){
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data['walletToken'];
    var token = localStorage.getItem('wallet-token');
   
     let headers = new HttpHeaders();
    headers = headers.append("authToken",localStorage.getItem('wallet-token'));

    return this.http.get(`${environment.validate_url}/ym/retailor/bank/deletebank?bankAccount=${bankAccount}`,{headers:headers});
  }
  setAsPrimary(accountDetails){
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data['walletToken'];
    var token = localStorage.getItem('wallet-token');

    var data={
      uacid: accountDetails.uacid,
      beneficiary_id:accountDetails.beneficiary_id,
      bank_name:accountDetails.bank_name,
      branch_name:accountDetails.branch_name,
      account_name:accountDetails.account_name,
      ifsc_code:accountDetails.ifsc_code,
      account_no:accountDetails.account_no,
      address:accountDetails.address,
      phone_no:accountDetails.phone_no,
      email:accountDetails.email,
      state:accountDetails.state,
      city:accountDetails.city,
      pin_code:accountDetails.pin_code,
      is_primary:true,
      created_by:accountDetails.created_by,
      wallet_token:token,
    
    }
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    return this.http.post(`${environment.youmudraUrl}/v1/retailer/setPrimaryBank`,data,{headers:headers});
  }
  setAsPrimary2(bankAccount,otp,ref){
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data['walletToken'];
    var token = localStorage.getItem('wallet-token');

 
    let headers = new HttpHeaders();
    headers = headers.append("authToken",localStorage.getItem('wallet-token'));

    return this.http.get(`${environment.validate_url}/ym/retailor/bank/setprimary?bankAccount=${bankAccount}&otp=${otp}&ref=${ref}`,{headers:headers});
  }

  searchbankbyifsc(ifsc){
    let headers = new HttpHeaders();
    headers = headers.append('apikey', environment.api_key);
    return this.http.get(`${environment.baseUrl}/v1/api/get/bank/byifsc?ifsc_code=${ifsc}`,{headers:headers});
  }

  sendOtpforaddbank(number,type){
    const phone ={
      phone:number,
      type:type

    }
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    return this.http.post(`${environment.youmudraUrl}/v1/user/dmtverifyUserOtp`,phone,{headers:headers});
  }
  sendOtpforaddbank2(type,otpOn){
    
    let headers = new HttpHeaders();
    headers = headers.append("authToken",localStorage.getItem('wallet-token'));

    return this.http.get(`${environment.validate_url}/ym/retailor/bank/send/otp?type=${type}&otpOn=${otpOn}`,{headers:headers});
  }
  ValiidateUserOtp(phone,otp){
    var data ={
      otp:otp,
      phone:phone
    }
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    return this.http.post(`${environment.youmudraUrl}/v1/user/validateUserOtp`,data,{headers:headers});
  }

  ValiidateUserOtp2(phone,otp){
    var data ={
      otp:otp,
      phone:phone
    }
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    return this.http.post(`${environment.youmudraUrl}/v1/user/validateUserOtp`,data,{headers:headers});
  }
addNewBank(form){
    console.log("form add bank:::",form)
    console.log("form :::",form.value.acHolder.split(" ").join("") +Date.now())
    var data={
      beneficiary_id:form.value.acHolder.split(" ").join("") +Date.now(),
      uacid: this.userData.data['uacid'],
      bank_name: form.value.Bank,
      branch_name: " ",
      account_name: form.value.acHolder,
      ifsc_code: form.value.Ifsc,
      account_no: form.value.acNumber.toString(),
      address: " ",
      phone_no: form.value.Mobile,
      email:this.userData.data['eamil'], 
      state:'',
      city:'' ,
      pin_code: "",
      is_primary: false,
      created_by:this.userData.data['agent_id'],
      wallet_token:this.userData.data['walletToken'],


    }
    console.log(data);
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    return this.http.post(`${environment.youmudraUrl}/v1/retailer/addBanak`,data,{headers:headers});
  
    
  }
  addNewBank2(form,value,value1){
    console.log("form add bank:::",form)
    console.log("form :::",form.value.acHolder.split(" ").join("") +Date.now())
    var data={
      bankBeneficiaryId:form.value.acHolder.split(" ").join("") +Date.now(),
      // uacid: this.userData.data['uacid'],
      bankName: form.value.Bank,
      bankBranch: " ",
      nameOnBank: form.value.acHolder,
      bankIfsc: form.value.Ifsc,
      bankAccountNumber: form.value.acNumber.toString(),
      address: " ",
      phone_no: form.value.Mobile,
      // email:this.userData.data['eamil'], 
      bankState:'',
      bankCity:'' ,
      bankPincode: "",
      otp:value,
      refNumber:value1,
      is_primary: false,
      // created_by:this.userData.data['agent_id'],
      // wallet_token:this.userData.data['walletToken'],


    }
    console.log(data);
    let headers = new HttpHeaders();
    headers = headers.append("authToken",localStorage.getItem('wallet-token'));

    return this.http.post(`${environment.validate_url}/ym/retailor/bank/add`,data,{headers:headers});
  
    
  }

  
  accountDetailsVerify(accdetails) {
    var type="NONE";
    var bene=accdetails;
    var mobile = bene.phone_no;
    let headers = new HttpHeaders();
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
    var token = localStorage.getItem('wallet-token')
    headers = headers.append('authToken', token);
    headers = headers.append('apikey', environment.api_key);

  var data={
  bankAccountNumber: bene.account_no,
  ifsccode: bene.ifsc_code,
  nameOnBank: bene.account_name,
  phoneNumber: bene.phone_no
   
  }
  console.log(data);
    return this.http.post(`${environment.baseUrl}/v1/ym/retailor/verify/bankAccount?mobileNumber=${mobile}&type=${type}`,data,{headers:headers});
  }
  accountDetailsVerify2(bankAccount) {
   
    let headers = new HttpHeaders();
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
    // headers = headers.append('authToken', token);
    headers = headers.append("authToken",localStorage.getItem('wallet-token'));

    return this.http.get(`${environment.validate_url}/ym/retailor/bank/updateverify?bankAccount=${bankAccount}`,{headers:headers});
  }
  updatebeneDetailsAfterVerification(nameOnBank,accdetails){
    var bene=accdetails;
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    var data={
      "account_name": nameOnBank,
      "_id":bene._id 
      }
    return this.http.post(`${environment.youmudraUrl}/v1/retailer/updateBankDetails`,data,{headers:headers});

  }
  bankverifyUpdate(accdetails){
    var bene=accdetails;
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    var data={
      verified: true,
      id:bene._id 
      }
    return this.http.post(`${environment.youmudraUrl}/v1/retailer/bankverifyUpdate`,data,{headers:headers});


  }
  

}
